import { __assign, __extends, __rest } from "tslib";
import { Shape, LineJoin, LineCap } from '../types';
import { DisplayObject } from './DisplayObject';

var Text =
/** @class */
function (_super) {
  __extends(Text, _super);

  function Text(_a) {
    if (_a === void 0) {
      _a = {};
    }

    var style = _a.style,
        rest = __rest(_a, ["style"]);

    return _super.call(this, __assign({
      type: Shape.TEXT,
      style: __assign({
        text: '',
        fontSize: 'inherit',
        fontFamily: 'inherit',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontVariant: 'normal',
        textAlign: 'inherit',
        textBaseline: 'alphabetic',
        dropShadow: false,
        // dropShadowAlpha: 1,
        // dropShadowAngle: Math.PI / 6,
        // dropShadowBlur: 0,
        // dropShadowColor: '#000',
        dropShadowDistance: 5,
        fill: '#000',
        letterSpacing: 0,
        lineHeight: 0,
        lineJoin: LineJoin.MITER,
        lineCap: LineCap.BUTT,
        lineWidth: 0,
        miterLimit: 10,
        stroke: '#000',
        whiteSpace: 'pre',
        wordWrap: false,
        wordWrapWidth: 0,
        leading: 0,
        dx: 0,
        dy: 0
      }, style)
    }, rest)) || this;
  }

  Text.prototype.getLineBoundingRects = function () {
    var _a;

    return ((_a = this.parsedStyle.metrics) === null || _a === void 0 ? void 0 : _a.lineMetrics) || [];
  };

  return Text;
}(DisplayObject);

export { Text };